export default "__VITE_ASSET__DrfpY7V0__"